import AccountMarketingMaterialWeddingFlyerTemplate from './AccountMarketingMaterialWeddingFlyerTemplate';

export default AccountMarketingMaterialWeddingFlyerTemplate;
